var map = {
	"./aed.png": 508,
	"./aud.png": 509,
	"./bgn.png": 510,
	"./bhd.png": 511,
	"./cad.png": 512,
	"./chf.png": 513,
	"./cny.png": 514,
	"./czk.png": 515,
	"./dkk.png": 516,
	"./eur.png": 517,
	"./gbp.png": 518,
	"./hkd.png": 519,
	"./hrk.png": 520,
	"./huf.png": 521,
	"./idr.png": 522,
	"./ils.png": 523,
	"./inr.png": 524,
	"./jpy.png": 525,
	"./kes.png": 526,
	"./kwd.png": 527,
	"./mxn.png": 528,
	"./myr.png": 529,
	"./nok.png": 530,
	"./nzd.png": 531,
	"./omr.png": 532,
	"./php.png": 533,
	"./pln.png": 534,
	"./qar.png": 535,
	"./ron.png": 536,
	"./rub.png": 537,
	"./sar.png": 538,
	"./sek.png": 539,
	"./sgd.png": 540,
	"./thb.png": 541,
	"./try.png": 542,
	"./ugx.png": 543,
	"./usd.png": 544,
	"./zar.png": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;